import { TreeGroupItem } from './TreeGroup';

export const SideMenuItems: TreeGroupItem[] = [
  {
    id: '01',
    name: '案件',
    subMenus: [
      {
        id: '0101',
        name: '案件一覧',
        to: '/projectList',
        activePathPrefixes: ['/projectDetail/', '/projectInfluencerDetail/'],
      },
      {
        id: '0102',
        name: '投稿制作管理',
        to: '/productionTeamList',
        activePathPrefixes: ['/productionProjectList/'],
      },
    ],
  },
  {
    id: '02',
    name: 'インフルエンサー',
    subMenus: [
      {
        id: '0201',
        name: 'インフルエンサー一覧',
        to: '/influencerList',
        activePathPrefixes: ['/influencerDetail/'],
      },
    ],
  },
  {
    id: '03',
    name: 'お知らせ',
    subMenus: [
      {
        id: '0301',
        name: '企業向け',
        to: '/companyNoticeList',
        activePathPrefixes: ['/companyNoticeUpdate/'],
      },
      {
        id: '0302',
        name: '企業バナー',
        to: '/companyBannerNoticeList',
        activePathPrefixes: ['/companyBannerNoticeUpdate/', '/companyBannerNoticeCreate'],
      },
      {
        id: '0303',
        name: 'インフルエンサー向け',
        to: '/influencerNoticeList',
        activePathPrefixes: ['/influencerNoticeUpdate/'],
      },
    ],
  },
  {
    id: '04',
    name: '請求・支払い',
    subMenus: [
      {
        id: '0401',
        name: '企業請求',
        to: '/companyBilling',
      },
      {
        id: '0402',
        name: 'インフルエンサー支払い',
        to: '/influencerBilling',
      },
    ],
  },
  {
    id: '05',
    name: '広告',
    subMenus: [
      {
        id: '0501',
        name: 'インフィード広告一覧',
        to: '/infeedAdList',
        activePathPrefixes: ['/infeedAdUpdate/'],
      },
      {
        id: '0502',
        name: '新規入稿',
        to: '/infeedAdCreate',
      },
    ],
  },
  {
    id: '06',
    name: '企業',
    subMenus: [
      {
        id: '0601',
        name: 'チーム一覧',
        to: '/teamList',
        activePathPrefixes: ['/teamDetail/'],
      },
      {
        id: '0602',
        name: '企業担当者一覧',
        to: '/companyList',
        activePathPrefixes: ['/companyDetail/'],
      },
    ],
  },
  {
    id: '07',
    name: '設定',
    subMenus: [
      {
        id: '0701',
        name: '社内担当者一覧',
        to: '/InsideCompanyMemberList',
      },
    ],
  },
];
